const appDataCache = new Map();

export const appDataCacheUtils = {
  get(appId) {
    if (!appId) return null;
    const entry = appDataCache.get(String(appId));
    return entry?.data || null;
  },
  getAppName(appId) {
    if (!appId) return null;
    const entry = appDataCache.get(String(appId));
    return entry?.data?.app?.name || null;
  },
  async fetchAppData(appId) {
    if (!appId) {
      return { ok: false, data: null };
    }

    const cacheKey = String(appId);
    const cachedEntry = appDataCache.get(cacheKey);
    if (cachedEntry?.data) {
      return { ok: true, data: cachedEntry.data };
    }
    if (cachedEntry?.promise) {
      return cachedEntry.promise;
    }

    const requestPromise = fetch(`/api/apps/${cacheKey}`, {
      credentials: "include",
    })
      .then(async (response) => {
        let data = null;
        try {
          data = await response.json();
        } catch (error) {
          data = null;
        }

        if (response.ok && data?.app) {
          appDataCache.set(cacheKey, { data });
          return { ok: true, data };
        }

        appDataCache.delete(cacheKey);
        return { ok: false, data };
      })
      .catch((error) => {
        appDataCache.delete(cacheKey);
        return { ok: false, data: null, error };
      });

    appDataCache.set(cacheKey, { promise: requestPromise });
    return requestPromise;
  },
  clear(appId) {
    if (!appId) return;
    appDataCache.delete(String(appId));
  },
};
